import gql from "graphql-tag";

export const APPLICATIONS_QUERY = gql`
query ApplicationsQuery($language: String!) {
  applications(language: $language) {
    id
    name
  }
}
`

export const LANGUAGES_QUERY = gql`
  query LanguagesQuery {
    languages {
      value
      display
    }
  }
`;

export const TAGS_QUERY = gql`
  query TagsQuery(
    $language: String!
    $offset: Int = 0
    $limit: Int = 10
    $q: String
  ) {
    tags(language: $language, offset: $offset, limit: $limit, q: $q) {
      id
      name
      visible
    }
  }
`;

export const CATEGORIES_QUERY = gql`
  query CategoriesQuery($language: String!, $applicationId: ID!) {
    categories(language: $language, applicationId: $applicationId) {
      id
      name
      iconUrl
      description
      order
      applicationId
    }
  }
`;

export const LIST_TABLES_QUERY = gql`
  query ListTablesQuery {
    listTables {
      className
      shards
      managedClasses {
        forcls
        indexes {
          columns
        }
      }
    }
  }
`;

export const LIST_BEANS_QUERY = gql`
  query ListBeansQuery(
    $className: String!
    $offset: Int
    $size: Int
    $userId: String
    $type: String
    $extId: String
  ) {
    listBeans(
      className: $className
      offset: $offset
      size: $size
      userId: $userId
      type: $type
      extId: $extId
    ) {
      edges {
        id
        created
        json
      }
      pageInfo {
        offset
        size
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js